import React from 'react';
import styled from '@emotion/styled';
import useAuthStore from 'stores/useAuthStore';

const MaintenancePage: React.FC = () => {
  const { accessCode } = useAuthStore();

  return (
    <Container>
      <Content>
        {/* 로컬은 임시로 EXTERNAL에 맞게 박아놓음 */}
        {accessCode === 'LOCAL' && (
          <Title>
            New-ERP 오픈에 따른 VARS(지급계좌등록시스템) 중단 및 모든 기능 서비스 불가 안내 / Notice
            of VARS(Vendor Account Registration System) system shutdown and blocking of all
            functions due to New-ERP Open
          </Title>
        )}
        {accessCode === 'EXTERNAL' && (
          <Title>
            시스템 작업에 따른 VARS(지급계좌등록시스템) 중단 및 모든 기능 서비스 불가 안내 / Notice
            of VARS(Vendor Account Registration System) system shutdown and blocking of all
            functions due to work on the system
          </Title>
        )}
        {accessCode === 'INTERNAL' && (
          <Title>
            New-ERP 오픈에 따른 VARS(지급계좌등록시스템) 중단 및 모든 기능 서비스 불가 안내 / Notice
            of VARS(Vendor Account Registration System) system shutdown and blocking of all
            functions due to New-ERP Open
          </Title>
        )}
        {/* {accessCode === 'EXTERNAL' && (
          <Message1>
            VARS 시스템 작업으로 인해 시스템이 중단되었습니다. 시스템 중단 기간 동안 모든 기능
            이용이 불가하오니 참고 부탁드립니다.
          </Message1>
        )}
        {accessCode === 'INTERNAL' && (
          <Message1>
            New ERP 오픈 대응으로 인해 VARS 시스템이 중단되었습니다. 시스템 중단 기간 동안 모든 기능
            이용이 불가하오니 참고 부탁드립니다.
          </Message1>
        )} */}
        <Message2>[시스템 중단 일정]</Message2>
        <Message3>
          25/06/28 (토) 21:00 ~ 25/06/30 (월) 06:00 [한국시간 기준, GMT+9] <br />→ 25/06/28 (토)
          08:00 ~ 25/06/29 (일) 17:00 [미국 동부 기준, GMT-4] <br /> → 25/06/28 (토) 07:00 ~
          25/06/29 (일) 16:00 [미국 중부 기준, GMT-5] <br /> → 25/06/28 (토) 13:00 ~ 25/06/29 (일)
          22:00 [중앙 유럽 기준, GMT+1] <br /> → 25/06/28 (토) 20:00 ~ 25/06/30 (월) 05:00 [중국
          표준시, GMT+8] <br /> → 25/06/28 (토) 19:00 ~ 25/06/30 (월) 04:00 [인도네시아 서부 기준,
          GMT+7]
        </Message3>
        <br />
        <Message2>[문의처]</Message2>
        <Message3>
          - LG 에너지솔루션 : 업무혁신.ERP.ERP운영1팀 진민하 사원 (minha.jin@lgensol.com)
          <br /> - LG CNS : 화학/전지경영정보DX팀 전형준 사원 (brotherjuns@lgespartner.com)
        </Message3>

        <Message1>
          --------------------------------------------------------------------------------------------------------------------{' '}
          <br />
          {/* {accessCode == 'EXTERNAL' && (
            <Message1>
              Due to work on the VARS system, the VARS system is shut down and all functions are
              blocked at the following time.
            </Message1>
          )}
          {accessCode == 'INTERNAL' && (
            <Message1>
              Due to preparation for ERP Open, the VARS system is shut down and all functions are
              blocked at the following time.
            </Message1>
          )} */}
        </Message1>
        <Message2>[Schedule of system outages]</Message2>
        <Message3>
          25/06/28(Sat.) 21:00 ~ 25/06/30(Mon.) 06:00[KST, GMT+9] <br />→ [USA(Eastern)
          Timezone(GMT-4) : 25/06/28(Sat.) 08:00 ~ 25/06/29(Sun.) 17:00] <br /> → [USA(Central)
          Timezone(GMT-5) : 25/06/28(Sat.) 07:00 ~ 25/06/29(Sun.) 16:00] <br /> → [Central EU
          Timezone(GMT+1) : 25/06/28(Sat.) 13:00 ~ 25/06/29(Sun.) 22:00] <br /> → [China Standard
          Timezone(GMT+8) : 25/06/28(Sat.) 20:00 ~ 25/06/30(Mon.) 05:00] <br /> → [Indonesia Western
          Timezone(GMT+7) : 25/06/28(Sat.) 19:00 ~ 25/06/30(Mon.) 04:00]
        </Message3>
        <br />
        <Message2>[Contact]</Message2>
        <Message3>
          - LG Energy Solution : ERP Operation1 Team Minha Jin (minha.jin@lgensol.com)
          <br /> - LG CNS : Chemical/Battery Business Information DX Team Hyeongjun Jeon
          (brotherjuns@lgespartner.com)
        </Message3>
      </Content>
    </Container>
  );
};

/* MaintenancePage.css */

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
  text-align: center;
`;

const Content = styled.div`
  max-width: 1000px;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
`;

const Message1 = styled.div`
  font-size: 18px;
  color: #555;
`;

const Message2 = styled.div`
  font-size: 18px;
  color: #555;
  font-weight: bold;
`;

const Message3 = styled.div`
  font-size: 18px;
  color: #007bff; /* 파란색 */
  text-align: center;
`;

export default MaintenancePage;
